/*------------------------------------*\
    MODULES
\*------------------------------------*/
import { debounce } from 'debounce';

/*------------------------------------*\
    SITE HEAD
\*------------------------------------*/
class SiteHead {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.toggleClass();

        window.addEventListener('scroll', evt => {
            self.toggleClass();
        });

    }

    toggleClass() {
        let self = this;

        if (window.scrollY > 0) {
            self.elem.classList.add('is-shrunk');
        } else {
            self.elem.classList.remove('is-shrunk');
        }
    }

}

export default SiteHead;
